import React, { Fragment } from 'react';
import '../loggedOut.css';

const Respite = () => {
return (
    <Fragment>
        <div className="logged-out">
            <section className="service-hero scene scene--hero page-hero">
                <div className="container">
                    <div className="hero-grid">
                        <div className="hero-copy">
                            <h1 className="display-5 mb-4">Respite</h1>
                            <p className="lead">
                                Based at our house in North Plympton, respite offers clients and their families a getaway space. Our respite location is designed to be as welcoming and homey as possible. It has been furnished and carefully curated by one of our passionate staff members Grace (see "The Team").
                            </p>
                        </div>
                        <div className="hero-media">
                            <div className="image-shell image-shell--hero">
                                <img
                                    src="/marketing_images/respite_house/1.png"
                                    alt="Respite house interior"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-story scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <div className="row align-items-center g-5">
                            <div className="col-md-6 order-2 order-md-1">
                                <p className="mb-0">
                                Grace's vision for the respite house has created an amazing, welcoming and accessible space where our clientele can be supported during short term stays. With a well-equipped kitchen, laundry and heaps of activities - our respite space is your home away from home!
                                </p>
                            </div>
                            <div className="col-md-6 order-1 order-md-2">
                                <div className="image-shell">
                                    <img
                                        src="/marketing_images/respite_house/2.png"
                                        alt="Respite house interior"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Fragment>
);

}

export default Respite;
